import React from 'react';
import { Button } from 'react-bootstrap';
import './AiChatStyle.css';

/**
 * Format a session list timestamp.
 *
 * @param {string|undefined} iso
 * @returns {string}
 */
function formatSessionTime(iso) {
  if (!iso) return '';
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
}

/**
 * Sidebar list of owner-scoped AI chat sessions.
 *
 * @param {Object} props
 * @param {Array<Object>} props.sessions
 * @param {number|string|null} props.activeSessionId
 * @param {function} props.onSelect
 * @param {function} props.onNewChat
 * @param {function} props.onArchive
 * @param {boolean} [props.disabled]
 * @returns {JSX.Element}
 */
const AiChatSessionList = ({
  sessions = [],
  activeSessionId,
  onSelect,
  onNewChat,
  onArchive,
  disabled = false,
}) => (
  <aside className="ai-chat-sessions" aria-label="Chat sessions">
    <Button
      size="sm"
      variant="outline-primary"
      className="w-100 mb-2"
      onClick={onNewChat}
      disabled={disabled}
    >
      New chat
    </Button>
    {sessions.map(session => {
      const isActive = String(session.id) === String(activeSessionId);
      const title = session.title?.trim() || `Chat ${session.id}`;
      return (
        <div key={session.id} className="mb-1">
          <button
            type="button"
            className={`ai-chat-sessions__item${isActive ? ' is-active' : ''}`}
            onClick={() => onSelect(session.id)}
            disabled={disabled}
          >
            <span>{title}</span>
            <span className="ai-chat-sessions__meta">
              {session.message_count ?? 0} msgs
              {session.updated_at
                ? ` · ${formatSessionTime(session.updated_at)}`
                : ''}
            </span>
          </button>
          {isActive && (
            <Button
              size="sm"
              variant="link"
              className="p-0 ms-1 text-danger"
              style={{ fontSize: '0.7rem' }}
              onClick={() => onArchive(session.id)}
              disabled={disabled}
            >
              Archive
            </Button>
          )}
        </div>
      );
    })}
  </aside>
);

export default AiChatSessionList;
